import { useState } from 'react'
import type { SourceId } from '../../../../Flux/Slice/Visualization/VisualizationSliceTypes.js'
import { AddSinkMenu } from '../Sources/AddSinkMenu.js'
import { useAddSink } from '../Sinks/SinksSidebarPanel.js'

export default function AddChartTile({ sourceId }: { sourceId: SourceId }) {
  const [open, setOpen] = useState(false)
  const addSink = useAddSink(sourceId)

  return (
    <div data-testid="viz-add-chart-tile">
      <AddSinkMenu
        sourceId={sourceId}
        open={open}
        onToggle={() => setOpen((o) => !o)}
        onSelect={(kind) => {
          addSink(kind)
          setOpen(false)
        }}
        label="+ Add chart"
        triggerClassName="btn btn-ghost w-full h-20 border-2 border-dashed border-base-300 text-base-content/60"
        placement="top"
      />
    </div>
  )
}
